import { Button, Checkbox, FormControlLabel, Grid, Typography } from "@mui/material";
import { useFormik } from "formik";
import { Link } from 'react-router-dom';
import { toast } from "react-toastify";
import * as Yup from 'yup';
import useEffectAsync from "../../lib/helper/useEffectAsync";
import { httpClient } from "../../lib/HttpClient";
import useTranslation from  "../../lib/localization";


export default function NotificationSettings() {
    const t = useTranslation();
    var schema = Yup.object({
        paymentSettings: Yup.object({
            paymentApprovalMargin: Yup.number().min(0).required(t("shared.mandatory"))
        })
    })

    var formik = useFormik({
        // validationSchema: schema,
        initialErrors: false,
        initialValues: {
            channels: [],
            availableEvents: []
        }
    })


    useEffectAsync(async () => {
        try {
            var response = await httpClient.Get("api/notificationSettings");


            formik.setValues(response);
        } catch (error) {
            toast.error(error.toString())
        }
    }, [])

    const handleSubmit = async () => {
        try {
            var response = await httpClient.Put("api/notificationSettings", formik.values);
            toast.success(t('settings.saved'))
        } catch (error) {
            toast.error(error.toString())
        }
    }

    const handleSelectChannel = (index) => (event) => {
        formik.values.channels[index].isSelected = event.target.checked
        formik.setValues(formik.values)
    }

    const handleSelectEvent = (channelIndex) => (event) => {
        if (event.target.checked) {

            formik.values.channels[channelIndex].selectedEventIds =
                [...formik.values.channels[channelIndex].selectedEventIds, Number(event.target.value)]
            formik.setValues(formik.values);
        } else {

            formik.values.channels[channelIndex].selectedEventIds =
                formik.values.channels[channelIndex].selectedEventIds.filter(c => c !== Number(event.target.value));
            formik.setValues(formik.values);
        }

    }

    return (
        <>
            <Typography variant="h4">
                {t("settings.notificationSettings")}
            </Typography>

            {


                formik.values.channels.map((c, channelIndex) => {
                    return (
                        <Grid container direction='column'>
                            <Grid container>
                                <FormControlLabel
                                    label={c.channelName}
                                    key={c.channelName}
                                    control={
                                        <Checkbox
                                            checked={c.isSelected}
                                            onChange={handleSelectChannel(channelIndex)}
                                        />
                                    }
                                />
                                <Button
                                    color='success'
                                    variant='outlined'
                                    component={Link}
                                    disabled={!c.isSelected}
                                    to={`/notification/configure/${c.channelName}`}
                                    // onClick={createPayment(id)}
                                    size="small">{t('configure')}</Button>

                            </Grid>
                            <Typography>
                                Events:
                            </Typography>
                            <Grid sx={{ marginLeft: 5 }} container>
                                {
                                    formik.values.availableEvents.map((e) => {

                                        return (
                                            <FormControlLabel
                                                disabled={!c.isSelected}
                                                label={e.eventName}
                                                key={e.eventName}
                                                control={
                                                    <Checkbox
                                                        checked={c.selectedEventIds.includes(e.eventId)}

                                                        value={e.eventId}
                                                        onChange={handleSelectEvent(channelIndex)}
                                                    />
                                                }
                                            />
                                        )
                                    })
                                }
                            </Grid>


                        </Grid>

                    )
                })

            }

            <Grid item xs={12} md={6}>
                <Button onClick={handleSubmit} disabled={!formik.isValid} variant="contained" >{t('Save')} </Button>
            </Grid>
        </>
    )
}